/* Strength Metrics — gym sign-up form (ported from the Webflow embed).
   Stripe card payments + subscription via the Vercel API below. */

const STRIPE_KEY = 'pk_live_51Qsyx3AUfrmlTJX5FlyBc7mGp3d0RvLJpThl5L5URl0RSDeRfaJmQ3pIOMGmix4X4juPpgTY8ZZ8BdOcryVKYoee00icoaQrBs';

const PRICE_IDS = {

  student:  {
    weekly:     'price_1TZ1VoAUfrmlTJX5WGIPxDng',
    sixmonthly: 'price_1TZ1amAUfrmlTJX595ATVmAU',
    yearly:     'price_1TZ1bsAUfrmlTJX5S8fzCeYx'
  },
  southern: {
    weekly:     'price_1TZ1WjAUfrmlTJX5hbi4LrUG',
    sixmonthly: 'price_1TZ1bAAUfrmlTJX5Rr7CPd8J',
    yearly:     'price_1TZ1cKAUfrmlTJX5oUa0euSE'
  },
  standard: {
    weekly:     'price_1TZ1X1AUfrmlTJX5oPOTXr2g',
    sixmonthly: 'price_1TZ1bTAUfrmlTJX5pQbKy8TY',
    yearly:     'price_1TZ1cgAUfrmlTJX5YtC8aUq8'
  },

  casual: {
    day:  'price_1RSNXIAUfrmlTJX5uUkhqWCJ',
    week: 'price_1RSNY9AUfrmlTJX5jRY209pt'
  }
};

const API_URL = 'https://project-2kcay.vercel.app/api/create-subscription';

const PRICES = {
  student:  { weekly: 19.95, sixmonthly: 498,  yearly: 954  },
  southern: { weekly: 22.95, sixmonthly: 573,  yearly: 1098 },
  standard: { weekly: 24.95, sixmonthly: 623,  yearly: 1194 },
  casual:   { day: 10, week: 30 }
};

// Google Ads: counts a completed sign-up as a conversion. Passes and upfront
// memberships count at their price; a weekly membership counts as 13 weeks of
// payments (about three months). The conversion to count ("AW-.../...") is set on
// the form's section in the theme editor. If that's blank, or the Google tag
// (snippets/sm-google-ads.liquid) isn't on the page, nothing is sent.
const WEEKLY_VALUE_WEEKS = 13;
function trackSignup(paymentId) {
  const sendTo = (document.getElementById('sm-join').dataset.adsConversion || '').trim();
  if (!sendTo || typeof gtag !== 'function') return;
  const casual = state.entry === 'casual';
  const price  = casual ? PRICES.casual[state.casual] : PRICES[state.type][state.term];
  const value  = !casual && state.term === 'weekly' ? price * WEEKLY_VALUE_WEEKS : price;
  const params = { send_to: sendTo, value: Math.round(value * 100) / 100, currency: 'NZD' };
  if (paymentId) params.transaction_id = paymentId;
  try { gtag('event', 'conversion', params); } catch (e) {}
}

const TYPE_NAMES   = { student: 'Student', southern: 'Southern Powerlifting', standard: 'Standard' };
const TERM_NAMES   = { weekly: 'Weekly', sixmonthly: '6-Monthly', yearly: 'Yearly' };
const TERM_WORDS   = { weekly: 'a week', sixmonthly: 'for 6 months', yearly: 'a year' };
const CASUAL_NAMES = { day: 'Day Pass', week: 'Week Pass' };
// What the form shows. The names above are what's sent to the payments API (and
// saved in Stripe and the sign-up emails), so they stay as they are.
const TERM_LABELS   = { weekly: 'Weekly', sixmonthly: '6-monthly', yearly: 'Yearly' };
const CASUAL_LABELS = { day: 'Day pass', week: 'Week pass' };

// "$19.95 a week", "$498 for 6 months"; passes are just "$10"
function priceText(withPeriod) {
  if (state.entry === 'casual') return '$' + PRICES.casual[state.casual];
  const amount = '$' + PRICES[state.type][state.term].toLocaleString('en-NZ');
  return withPeriod ? amount + ' ' + TERM_WORDS[state.term] : amount;
}
// What the customer is about to pay, in cents, for the API to check against Stripe
function amountCents() {
  const price = state.entry === 'casual' ? PRICES.casual[state.casual] : PRICES[state.type][state.term];
  return Math.round(price * 100);
}

// The choice cards work as radio buttons: mark the chosen one for assistive tech
function markChosen(selector, chosen) {
  document.querySelectorAll(selector).forEach(el => {
    const on = el === chosen;
    el.classList.toggle('selected', on);
    el.setAttribute('aria-checked', on ? 'true' : 'false');
  });
}

// Casual passes: the day (today up to 90 days ahead) and time they're coming in
const DAYS   = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
function isoDay(offset) {
  const d = new Date();
  d.setDate(d.getDate() + (offset || 0));
  return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
}
function visitOk() {
  return !!state.visitTime && !!state.visitDate && state.visitDate >= isoDay(0) && state.visitDate <= isoDay(90);
}
// "Saturday 11 October" (plus the year if asked), or "Sat 11 Oct" when short
function visitDayText(short, withYear) {
  const [y, m, d] = state.visitDate.split('-').map(Number);
  const day = DAYS[new Date(y, m - 1, d).getDay()], month = MONTHS[m - 1];
  return short ? day.slice(0, 3) + ' ' + d + ' ' + month.slice(0, 3) : day + ' ' + d + ' ' + month + (withYear ? ' ' + y : '');
}
// "18:00" as "6:00 pm"
function clockText(hhmm) {
  const [h, min] = hhmm.split(':').map(Number);
  return (h % 12 || 12) + ':' + String(min).padStart(2, '0') + (h < 12 ? ' am' : ' pm');
}
function visitTimeText() { return clockText(state.visitTime); }

const state = {
  entry:    null,
  type:     null,
  term:     null,
  casual:   null,
  visitDate: '',
  visitTime: '',
  compete:  null,
  coaching: null,
  injuries: null,
  referred: null
};

// Arrival times run every 15 minutes from the earliest to the latest set in the theme
// editor (7:00 am to 6:00 pm unless changed), grouped by part of the day. For today,
// times that have already passed are left out, and once the latest has passed the
// date starts on tomorrow.
// Set up before Stripe so step 1 works even if Stripe's script is slow or blocked.
(function () {
  const date = document.getElementById('visit-date'), time = document.getElementById('visit-time');
  if (!date || !time) return;
  const hour = (v, fallback) => { const h = parseInt(v, 10); return h >= 0 && h <= 23 ? h : fallback; };
  const from = hour(time.dataset.from, 7), to = hour(time.dataset.to, 18);
  const FIRST = Math.min(from, to) * 60, LAST = Math.max(from, to) * 60; // minutes after midnight
  const PARTS = [['Early hours', 0], ['Morning', 5], ['Afternoon', 12], ['Evening', 17], ['', 24]];
  // The current time in minutes after midnight, rounded down to the quarter hour
  const nowSlot = () => { const now = new Date(); return Math.floor((now.getHours() * 60 + now.getMinutes()) / 15) * 15; };
  function fillTimes() {
    const keep = time.value, start = Math.max(FIRST, date.value === isoDay(0) ? nowSlot() : 0);
    let html = '';
    for (let p = 0; p < PARTS.length - 1; p++) {
      let options = '';
      for (let m = Math.max(PARTS[p][1] * 60, start); m < PARTS[p + 1][1] * 60 && m <= LAST; m += 15) {
        const v = String(Math.floor(m / 60)).padStart(2, '0') + ':' + String(m % 60).padStart(2, '0');
        options += '<option value="' + v + '">' + clockText(v) + '</option>';
      }
      if (options) html += '<optgroup label="' + PARTS[p][0] + '">' + options + '</optgroup>';
    }
    time.innerHTML = '<option value="" disabled>' + (html ? 'Select a time' : 'No times left today') + '</option>' + html;
    time.value = keep;
    if (time.value !== keep || !keep) time.selectedIndex = 0; // earlier choice no longer on the list
  }
  const sync = () => { state.visitDate = date.value; state.visitTime = time.value; updateSummary(); checkStep1(); };
  date.min = isoDay(nowSlot() > LAST ? 1 : 0);
  date.max = isoDay(90);
  date.value = state.visitDate = date.min;
  fillTimes();
  ['input', 'change'].forEach(ev => date.addEventListener(ev, () => { fillTimes(); sync(); }));
  time.addEventListener('change', sync);
})();

(function () {
  const dob = document.getElementById('dob');
  if (dob) dob.max = isoDay(0);
})();

const stripe   = Stripe(STRIPE_KEY);
const elements = stripe.elements();
// The card field sits on the form's white card: black text, grey hints, and 16px
// so phones don't zoom in when it's tapped
const card     = elements.create('card', {
  style: {
    base: {
      color: '#000000',
      fontFamily: "'Inter', sans-serif",
      fontSize: '16px',
      fontWeight: '400',
      '::placeholder': { color: '#767676' },
      iconColor: '#5c5c5c'
    },
    invalid: { color: '#c0262d', iconColor: '#c0262d' }
  }
});

card.mount('#card-element');
// The payment method made from the card. If the connection drops after the API
// has taken the payment, the customer's retry sends the same one, and the API
// carries on with the sign-up it already has instead of charging twice. A new
// one is made as soon as the card details change.
let paymentMethodId = null;
card.on('change', e => {
  paymentMethodId = null;
  document.getElementById('card-errors').textContent = e.error ? e.error.message : '';
});
// Changed name, email or address details mean a fresh payment method too
document.getElementById('step-2').addEventListener('input', () => { paymentMethodId = null; });

function goTo(n) {
  document.querySelectorAll('.step').forEach(s => s.classList.remove('active'));
  document.getElementById('step-' + n).classList.add('active');
  document.querySelectorAll('.seg').forEach((s, i) => s.classList.toggle('on', i < n));
  if (n === 3) toggleInductionFields();
  if (n === 4) populateOrderSummary();
  smJoinScroll();
  const title = document.querySelector('#step-' + n + ' .step-title');
  if (title) title.focus({ preventScroll: true });
}

function showError(id, msg) {
  let el = document.getElementById(id + '-err');
  if (!el) {
    el = document.createElement('div');
    el.id = id + '-err';
    el.style.cssText = 'font-size:12px;color:#e05252;margin-top:5px;';
    const field = document.getElementById(id);
    field.parentNode.appendChild(el);
  }
  el.textContent = msg;
  document.getElementById(id).style.borderColor = '#e05252';
}

function clearError(id) {
  const el = document.getElementById(id + '-err');
  if (el) el.textContent = '';
  const field = document.getElementById(id);
  if (field) field.style.borderColor = '';
}

function validateStep2() {
  let valid = true;
  const required = [
    { id: 'fname',        label: 'First name is required' },
    { id: 'lname',        label: 'Last name is required' },
    { id: 'email',        label: 'Email is required' },
    { id: 'phone',        label: 'Phone number is required' },
    { id: 'dob',          label: 'Date of birth is required' },
    { id: 'addr-street',  label: 'Street address is required' },
    { id: 'addr-city',    label: 'City is required' },
    { id: 'addr-postcode',label: 'Postcode is required' },
    { id: 'ec-name',      label: 'Please add someone we can call in an emergency' },
    { id: 'ec-phone',     label: 'Their phone number is required' }
  ];

  required.forEach(({ id, label }) => {
    const val = document.getElementById(id).value.trim();
    if (!val) { showError(id, label); valid = false; }
    else clearError(id);
  });

  const email = document.getElementById('email').value.trim();
  if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    showError('email', 'Please enter a valid email address');
    valid = false;
  }

  const dob = document.getElementById('dob').value;
  if (dob && (dob > isoDay(0) || dob < '1900-01-01')) {
    showError('dob', 'Please check your date of birth');
    valid = false;
  }

  // The emergency contact has to be someone else, on a full phone number
  const digits = (id) => document.getElementById(id).value.replace(/\D/g, '').replace(/^64/, '0');
  const ecPhone = digits('ec-phone');
  if (ecPhone && ecPhone.length < 6) {
    showError('ec-phone', 'Please enter their full phone number');
    valid = false;
  } else if (ecPhone && ecPhone === digits('phone')) {
    showError('ec-phone', 'This needs to be someone else’s number');
    valid = false;
  }

  return valid;
}

function validateStep3() {
  let valid = true;

  if (!state.compete) {
    const el = document.querySelector('[data-group="compete"]').parentElement;
    let err = document.getElementById('compete-err');
    if (!err) {
      err = document.createElement('div');
      err.id = 'compete-err';
      err.style.cssText = 'font-size:12px;color:#e05252;margin-top:5px;';
      el.appendChild(err);
    }
    err.textContent = 'Please select an option';
    valid = false;
  } else {
    const err = document.getElementById('compete-err');
    if (err) err.textContent = '';
  }

  if (!state.coaching) {
    const el = document.querySelector('[data-group="coaching"]').parentElement;
    let err = document.getElementById('coaching-err');
    if (!err) {
      err = document.createElement('div');
      err.id = 'coaching-err';
      err.style.cssText = 'font-size:12px;color:#e05252;margin-top:5px;';
      el.appendChild(err);
    }
    err.textContent = 'Please select an option';
    valid = false;
  } else {
    const err = document.getElementById('coaching-err');
    if (err) err.textContent = '';
  }

  if (!state.injuries) {
    const el = document.querySelector('[data-group="injuries"]').parentElement;
    let err = document.getElementById('injuries-err');
    if (!err) {
      err = document.createElement('div');
      err.id = 'injuries-err';
      err.style.cssText = 'font-size:12px;color:#e05252;margin-top:5px;';
      el.appendChild(err);
    }
    err.textContent = 'Please select an option';
    valid = false;
  } else {
    const err = document.getElementById('injuries-err');
    if (err) err.textContent = '';
  }

  if (!state.referred) {
    const el = document.querySelector('[data-group="referred"]').parentElement;
    let err = document.getElementById('referred-err');
    if (!err) {
      err = document.createElement('div');
      err.id = 'referred-err';
      err.style.cssText = 'font-size:12px;color:#e05252;margin-top:5px;';
      el.appendChild(err);
    }
    err.textContent = 'Please select an option';
    valid = false;
  } else {
    const err = document.getElementById('referred-err');
    if (err) err.textContent = '';
  }

  const exp = document.getElementById('training-exp').value;
  if (!exp) {
    showError('training-exp', 'Please select your training experience');
    valid = false;
  } else {
    clearError('training-exp');
  }

  if (state.entry !== 'casual') {
    const day = document.getElementById('induction-day').value;
    const time = document.getElementById('induction-time').value;
    if (!day) { showError('induction-day', 'Please select a preferred day'); valid = false; }
    else clearError('induction-day');
    if (!time) { showError('induction-time', 'Please select a preferred time'); valid = false; }
    else clearError('induction-time');
  }

  return valid;
}

function selectEntry(el) {
  markChosen('.entry-btn', el);
  state.entry = el.dataset.entry;

  const isMembership = state.entry === 'membership';
  document.getElementById('membership-section').classList.toggle('show', isMembership);
  document.getElementById('casual-section').classList.toggle('show', !isMembership);

  if (isMembership) {
    state.casual = null;
    markChosen('.casual-card', null);
  } else {
    state.type = null;
    state.term = null;
    markChosen('.type-card, .term-card', null);
  }

  updateSummary();
  checkStep1();
}

function selectType(el) {
  markChosen('.type-card', el);
  state.type = el.dataset.type;
  refreshTermPrices();
  checkStep1();
}

function selectTerm(el) {
  markChosen('.term-card', el);
  state.term = el.dataset.term;
  updateSummary();
  checkStep1();
}

function selectCasual(el) {
  markChosen('.casual-card', el);
  state.casual = el.dataset.casual;
  const week = state.casual === 'week';
  document.getElementById('visit-date-label').textContent = week ? 'Start date' : 'Date';
  document.getElementById('visit-note').hidden = !week;
  updateSummary();
  checkStep1();
}

function refreshTermPrices() {
  if (!state.type) return;
  document.querySelectorAll('.term-card').forEach(tc => {
    tc.querySelector('.amt').textContent =
      PRICES[state.type][tc.dataset.term].toLocaleString('en-NZ');
  });
  updateSummary();
}

function updateSummary() {
  const label = document.getElementById('ps-label');
  const price = document.getElementById('ps-price');

  if (state.entry === 'membership' && state.type && state.term) {
    label.textContent = TYPE_NAMES[state.type] + ' · ' + TERM_LABELS[state.term];
    price.textContent = priceText(true);
  } else if (state.entry === 'casual' && state.casual) {
    label.textContent = CASUAL_LABELS[state.casual] + (visitOk() ? ' · ' + visitDayText(true) + ', ' + visitTimeText() : '');
    price.textContent = '$' + PRICES.casual[state.casual];
  } else {
    label.textContent = 'Select a plan above';
    price.textContent = '';
  }
}

function checkStep1() {
  const ok = (state.entry === 'membership' && state.type && state.term) ||
             (state.entry === 'casual' && state.casual && visitOk());
  document.getElementById('btn-step1').disabled = !ok;
}

function selectRadio(el) {
  const group = el.dataset.group;
  markChosen(`.radio-opt[data-group="${group}"]`, el);
  state[group] = el.dataset.val;
}

function showConditional(id, show) {
  document.getElementById(id).classList.toggle('show', show);
}

function toggleInductionFields() {

  document.getElementById('induction-fields').style.display =
    state.entry === 'casual' ? 'none' : 'block';
}

function populateOrderSummary() {
  const isCasual = state.entry === 'casual';

  document.getElementById('step4-title').textContent =
    isCasual ? 'Complete your purchase' : 'Complete your membership';

  if (isCasual) {
    document.getElementById('pay-type-label').textContent = 'Pass';
    document.getElementById('pay-type').textContent = CASUAL_LABELS[state.casual];
    document.getElementById('pay-billing-row').style.display = 'none';
    document.getElementById('pay-when-row').style.display = '';
    document.getElementById('pay-when').textContent = visitDayText(false) + ', ' + visitTimeText();
    document.getElementById('pay-amount').textContent = '$' + PRICES.casual[state.casual];
  } else {
    document.getElementById('pay-type-label').textContent = 'Membership';
    document.getElementById('pay-type').textContent = TYPE_NAMES[state.type];
    document.getElementById('pay-billing-row').style.display = '';
    document.getElementById('pay-when-row').style.display = 'none';
    document.getElementById('pay-term').textContent = TERM_LABELS[state.term];
    document.getElementById('pay-amount').textContent = priceText(true);
  }

  // Members get gym emails whether or not they tick the news box; casual passes don't
  const newsNote = document.getElementById('news-note');
  if (newsNote) newsNote.hidden = isCasual;
}

function checkTcs() {
  const checked = document.getElementById('tcs-check').checked;
  document.getElementById('submit-btn').disabled = !checked;
}

async function handleSubmit() {
  const btn   = document.getElementById('submit-btn');
  const errEl = document.getElementById('card-errors');
  const isCasual = state.entry === 'casual';

  btn.disabled = true;
  btn.textContent = 'Processing…';
  errEl.textContent = '';

  const fname = document.getElementById('fname').value.trim();
  const lname = document.getElementById('lname').value.trim();
  const name  = `${fname} ${lname}`.trim();

  const formData = {

    isCasual,
    priceId: isCasual
      ? PRICE_IDS.casual[state.casual]
      : PRICE_IDS[state.type][state.term],

    membershipType: isCasual ? CASUAL_NAMES[state.casual] : TYPE_NAMES[state.type],
    term:           isCasual ? 'One-time' : TERM_NAMES[state.term],

    name,
    email:    document.getElementById('email').value.trim(),
    phone:    document.getElementById('phone').value.trim(),
    dob:      document.getElementById('dob').value,
    address: {
      street:   document.getElementById('addr-street').value.trim(),
      city:     document.getElementById('addr-city').value.trim(),
      postcode: document.getElementById('addr-postcode').value.trim(),
      country:  'NZ'
    },
    emergencyName:  document.getElementById('ec-name').value.trim(),
    emergencyPhone: document.getElementById('ec-phone').value.trim(),
    // The email news tick (unticked unless they tick it)
    emailMarketing: !!(document.getElementById('news-check') || {}).checked,

    trainingExperience:   document.getElementById('training-exp').value,
    competesInPL:         state.compete === 'yes',
    interestedInCoaching: state.coaching === 'yes',
    hasInjuries:          state.injuries === 'yes',
    injuryDetail:         state.injuries === 'yes'
                            ? document.getElementById('injuries-text').value.trim()
                            : '',
    referred:             state.referred === 'yes',
    referredBy:           state.referred === 'yes'
                            ? document.getElementById('referrer').value.trim()
                            : '',
    // Casual passes also send their visit in the induction fields, for older versions of the API
    inductionDay:  isCasual ? 'Casual visit: ' + visitDayText(false, true) : document.getElementById('induction-day').value,
    inductionTime: isCasual ? visitTimeText() : document.getElementById('induction-time').value,
    visitDate:     isCasual ? state.visitDate : '',
    visitTime:     isCasual ? state.visitTime : ''
  };

  try {
    if (!paymentMethodId) {
      const { paymentMethod, error: pmErr } = await stripe.createPaymentMethod({
        type: 'card',
        card,
        billing_details: {
          name,
          email:   formData.email,
          phone:   formData.phone,
          address: {
            line1:       formData.address.street,
            city:        formData.address.city,
            postal_code: formData.address.postcode,
            country:     'NZ'
          }
        }
      });

      if (pmErr) {
        errEl.textContent = pmErr.message;
        btn.disabled = false;
        btn.textContent = 'Complete';
        return;
      }
      paymentMethodId = paymentMethod.id;
    }

    const res    = await fetch(API_URL, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ ...formData, paymentMethodId, expectedAmount: amountCents() })
    });
    const result = await res.json();

    if (!res.ok) {
      errEl.textContent = result.error || 'Something went wrong. Please try again.';
      btn.disabled = false;
      btn.textContent = 'Complete';
      return;
    }

    let paymentId = result.subscriptionId || result.paymentIntentId || '';
    if (result.clientSecret) {
      const { paymentIntent: verified, error: confirmErr } = await stripe.confirmCardPayment(result.clientSecret);
      if (confirmErr) {
        errEl.textContent = confirmErr.message;
        btn.disabled = false;
        btn.textContent = 'Complete';
        return;
      }
      // The bank asked the customer to verify the payment, so the API sends the
      // sign-up emails now that it's done
      if (verified && verified.id) {
        paymentId = paymentId || verified.id;
        fetch(API_URL, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body:    JSON.stringify({ complete: true, paymentIntentId: verified.id })
        }).catch(() => {});
      }
    }

    trackSignup(paymentId);
    document.querySelectorAll('.step, .progress-track').forEach(el => el.style.display = 'none');
    const s = document.getElementById('success');
    s.querySelector('p').innerHTML = isCasual
      ? `Enjoy your ${CASUAL_NAMES[state.casual].toLowerCase()}.<br>See you ${state.visitDate === isoDay(0) ? 'today' : state.visitDate === isoDay(1) ? 'tomorrow' : 'on ' + visitDayText(false)} at ${visitTimeText()}.<br><br>Questions? <a href="mailto:service@strengthmetrics.com">service@strengthmetrics.com</a>`
      : `Welcome to Strength Metrics.<br>We'll be in touch to confirm your induction.<br><br>Questions? <a href="mailto:service@strengthmetrics.com">service@strengthmetrics.com</a>`;
    s.classList.add('show');
    smJoinScroll();

  } catch (err) {
    errEl.textContent = 'We couldn’t reach our payment service. Check your connection and press Complete again; if the payment already went through, you won’t be charged twice.';
    btn.disabled = false;
    btn.textContent = 'Complete';
  }
}

// Scroll the form (not the whole page) back into view between steps.
function smJoinScroll() {
  var el = document.getElementById('sm-join');
  if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
}
